/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Model_High_HintInputs */

const en_landing_studio_model_high_hint = /** @type {(inputs: Landing_Studio_Model_High_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest fidelity for finals`)
};

const zh_landing_studio_model_high_hint = /** @type {(inputs: Landing_Studio_Model_High_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高画质，适合定稿`)
};

/**
* | output |
* | --- |
* | "Highest fidelity for finals" |
*
* @param {Landing_Studio_Model_High_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_model_high_hint = /** @type {((inputs?: Landing_Studio_Model_High_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Model_High_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_model_high_hint(inputs)
	return zh_landing_studio_model_high_hint(inputs)
});
export { landing_studio_model_high_hint as "landing.studio.model_high_hint" }